import { Component, inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Task } from 'src/models/task.model';
import { Priority } from '../../models/priority.model';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { APIResult } from '../../models/APIResult.model';

@Component({
    selector: 'app-task-details-modal',
    templateUrl: './task-details-modal.component.html',
    styleUrls: ['./task-details-modal.component.scss'],
    standalone: false
})
export class TaskDetailsModalComponent {

    @Input() public task: Task;
    public name: string;

    public taskImageUrls: string[] = [];
    protected readonly Priority = Priority;
    private http: HttpClient = inject(HttpClient);

    constructor(private modalController: ModalController) {
    }

    public async loadImages() {
        if (!this.task) {
            console.log('[TaskDetailsModalComponent] loadImages() - no task');
            return;
        }
        const url = environment.apiUrl + '/taskimages/' + this.task.id;
        this.taskImageUrls = [];
        this.http.get<APIResult<any>>(url).subscribe(apiResult => {

            // The response is an object with a data property. That data property is an array of objects and in those objects is a fileName property.
            // We want to extract the fileName property from each object in the array and add them to the taskImageUrls.

            let data = apiResult.data;
            if (!data) {
                return;
            }
            data = data.map(item => item.fileName);

            this.taskImageUrls = data;
        });
    }

    public cancel() {
        return this.modalController.dismiss(null, 'cancel');
    }

    public confirm() {
        return this.modalController.dismiss(this.name, 'confirm');
    }

    public completeTask() {
        console.log('APP [TaskDetailsModalComponent] completeTask() - invoked');
    }

    public getImageUrl(image: string): any {
        return environment.fileUrl + '/' + image;
    }

    // public toggleActionSheet(): void {
    //     this.actionSheetController
    //       .create({
    //         buttons: [
    //           {
    //             text: 'Taak wijzigen',
    //             icon: 'create-outline',
    //             handler: async () => {
    //               console.log('[TaskDetailsModalComponent] handler() - edit task please');
    //             },
    //           },
    //           {
    //             text: 'Annuleren',
    //             icon: 'close',
    //             role: 'cancel',
    //           },
    //         ],
    //       })
    //       .then((actionSheetEl) => {
    //         actionSheetEl.present();
    //       });
    // }
}
